import { render } from "./Media.vue?vue&type=template&id=e35e6f8e"
import script from "./Media.vue?vue&type=script&setup=true&lang=js"
export * from "./Media.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Ui/Media.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e35e6f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e35e6f8e', __exports__)) {
    api.reload('e35e6f8e', __exports__)
  }
  
  module.hot.accept("./Media.vue?vue&type=template&id=e35e6f8e", () => {
    api.rerender('e35e6f8e', render)
  })

}


export default __exports__